import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const code = new URLSearchParams(window.location.search).get("code");
    const sessionId = new URLSearchParams(window.location.hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        let data;
        if (code) {
          // Self-hosted Google OAuth flow
          const res = await api.post("/auth/google", {
            code,
            redirect_uri: window.location.origin + "/auth/google",
          });
          data = res.data;
        } else {
          // Emergent-managed flow (preview)
          const res = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
          data = res.data;
        }
        setUser(data);
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch {
        window.history.replaceState({}, "", "/");
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-ink-base" data-testid="auth-callback">
      <div className="animate-spinSlow">
        <Logo size={56} />
      </div>
    </div>
  );
};

export default AuthCallback;
